// When a participant may still cancel their place in an activity.
//
// A participation can be cancelled until `cancellationend` or `entryend` (the end of sign-up), whichever
// is first: cancelling never stays open after sign-up has closed (the venue manager's rule, and what
// activities-cancel enforces). Without `cancellationend`, `entryend` is the deadline, as it always was.
// Leaving the queue is not limited by `cancellationend`: it stays possible while sign-up is open.
// Both fields are Helsinki-local 'YYYY-MM-DDTHH:mm'.

import moment from 'moment-timezone'

// A Helsinki-local 'YYYY-MM-DDTHH:mm' as a UTC moment - the parse the activity views have always used.
export const helsinkiTime = (value) =>
  moment.utc(value, 'YYYY-MM-DDTHH:mm').subtract(moment().tz('Europe/Helsinki').utcOffset(), 'minutes')

export const cancelDeadline = (activity) => {
  const a = activity || {}
  // same format, so the strings compare in time order
  const value = [a.cancellationend, a.entryend].filter((x) => typeof x === 'string' && x).sort()[0]
  return value ? helsinkiTime(value) : null
}

// A participant can cancel until the deadline. No deadline at all: no cancelling, as before (the old
// parse of a missing entryend gave an invalid date, which is never after now).
export const canCancelParticipation = (activity, gtime) => {
  const deadline = cancelDeadline(activity)
  return Boolean(deadline && deadline.isValid() && moment(gtime).isBefore(deadline))
}

// Someone in the queue can leave while sign-up is open (before entryend).
export const canLeaveQueue = (activity, gtime) => {
  const a = activity || {}
  if (!a.entryend) return false
  const end = helsinkiTime(a.entryend)
  return end.isValid() && moment(gtime).isBefore(end)
}
